import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sportscabbookinginbanglore() {



  const cardData =
  {
    keyword: 'Sports Cab Bookings in Bangalore',
    heading: 'Aaryan Travels: Sports Cab Bookings in Bangalore',
    headingDescription: 'Aaryan Travels offers reliable Sports Cab Bookings in Bangalore for athletes, event organizers, and sports fans traveling to stadiums, tournaments, and practice venues across the city. Whether you are heading to M. Chinnaswamy Stadium, Kanteerava Stadium, indoor arenas, or training academies, our fleet of sedans, SUVs, and tempo travellers ensures safe and timely transportation. We also provide group cabs for team pickups, fan convoy services, and VIP transfers for sports personalities. With professional chauffeurs, well-maintained vehicles, and 24/7 availability, Aaryan Travels is the trusted partner for sports travel and event transportation in Bangalore.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green oasis in the heart of Bangalore, famous for its rare plant species and serene lakes. The Glass House, inspired by London’s Crystal Palace, hosts vibrant flower shows twice a year. Early mornings are filled with joggers, bird watchers, and photography enthusiasts. The centuries-old trees and peaceful ambiance make it a perfect escape from city life. Lalbagh is Bangalore’s timeless haven of nature and beauty."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, resembles a Tudor-style castle with fortified towers, wooden staircases, and elegant courtyards. Visitors can explore royal artifacts, vintage photographs, and grand halls used for ceremonies. The vast palace grounds often host concerts and cultural events. Its architecture blends opulence with historical charm. Bangalore Palace is the city’s royal symbol of heritage and splendor."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park spans over 300 acres of lush greenery and is a favorite spot for morning walkers, cyclists, and families. The park features colonial-era statues, bamboo groves, and shaded trails perfect for relaxation. Landmarks like the State Central Library and High Court are located nearby. Children enjoy the toy train rides inside the park. Cubbon Park is Bangalore’s refreshing urban lung space."
  },
  {
    "title": "ISKCON Temple",
    "description": "ISKCON Temple in Rajajinagar is one of the largest Krishna temples in the world, built with white marble and ornate carvings. Devotees attend soulful bhajans and rituals in a serene atmosphere. The temple complex includes a cultural museum and prasadam counters. The hilltop location offers beautiful views of the city. ISKCON is Bangalore’s spiritual sanctuary of devotion and peace."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from the city, Nandi Hills is a popular sunrise point offering breathtaking valley views. The hilltop fort has historical significance, being a summer retreat of Tipu Sultan. Visitors enjoy trekking, cycling, and early morning misty drives. The cool breeze and scenic beauty attract tourists year-round. Nandi Hills is Bangalore’s quick getaway to nature and adventure."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is the seat of Karnataka’s state legislature and one of India’s most impressive government buildings. Built in Neo-Dravidian style, it features massive granite pillars, domes, and intricate carvings. The grand structure is illuminated beautifully on Sunday evenings. It represents the dignity of governance and architectural excellence. Vidhana Soudha is Bangalore’s towering landmark of democracy."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park offers thrilling jeep safaris where visitors can spot tigers, lions, elephants, and bears roaming freely. The park also features a butterfly garden, reptile enclosures, and rescue centers. The lush forest setting makes it ideal for educational trips and wildlife photography. It is one of the few national parks within city reach. Bannerghatta is Bangalore’s wild encounter with nature."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most popular shopping lane filled with trendy apparel boutiques, footwear stores, and jewelry stalls. Bargain hunters enjoy exploring the narrow alleys packed with colorful merchandise. Street food carts add to the lively atmosphere. It is always buzzing with youngsters and tourists. Commercial Street is Bangalore’s vibrant hub of fashion and fun."
  },
  {
    "title": "UB City",
    "description": "UB City is Bangalore’s premier luxury commercial complex, hosting international brands, fine dining restaurants, and rooftop lounges. Its elegant architecture and open-air plaza often host live music and art events. Visitors enjoy gourmet experiences and upscale shopping. It offers a glimpse into the city’s modern, cosmopolitan lifestyle. UB City is Bangalore’s glamorous face of sophistication."
  },
  {
    "title": "MG Road and Brigade Road",
    "description": "MG Road and Brigade Road are iconic stretches known for nightlife, shopping, and entertainment. The streets are lined with pubs, cafes, bookstores, and fashion outlets. Festival lights and weekend crowds create a buzzing atmosphere. Street performers and local vendors add charm. MG Road is Bangalore’s lively heartbeat of urban culture."
  }
],



"services": [
  {
    "name": "Sports Cab Bookings in Bangalore",
    "description": "Sports Cab Bookings in Bangalore deliver an unmatched driving experience combining high performance, luxury, and convenience. This service is ideal for those who want to enjoy the thrill of riding in powerful sports cars while ensuring professional chauffeur-driven comfort. With a diverse range of vehicles including Ferrari, Lamborghini, Porsche, and BMW M-series models, customers can choose the perfect car for corporate events, city tours, or special occasions. Every booking comes with doorstep pickup, flexible hourly or daily packages, and full vehicle sanitization. Whether it's for a weekend getaway or an impressive client transfer, Sports Cab Bookings in Bangalore redefine premium travel with speed, style, and precision."
  },
  {
    "name": "Sports Car Hire Bangalore",
    "description": "Sports Car Hire Bangalore allows you to rent top-class sports vehicles that deliver both power and prestige. Perfect for corporate executives, auto enthusiasts, and special events, the fleet includes the latest models equipped with superior interiors, cutting-edge technology, and safety features. Customers can choose self-drive or chauffeur-driven options based on their preference. With 24/7 customer support, easy booking, and transparent pricing, Sports Car Hire Bangalore ensures every drive is exhilarating, safe, and memorable."
  },
  {
    "name": "Rent Sports Cab Bangalore",
    "description": "Rent Sports Cab Bangalore offers a convenient and flexible way to access luxury sports vehicles without ownership hassles. Ideal for business professionals, travelers, and event organizers, this service provides high-end cars with trained chauffeurs. Each cab is meticulously maintained and designed for comfort, performance, and elegance. It’s the ultimate choice for making an impression at corporate gatherings, parties, or city rides."
  },
  {
    "name": "Chauffeur Sports Car Bangalore",
    "description": "Chauffeur Sports Car Bangalore provides premium chauffeur-driven sports car experiences tailored for individuals who appreciate performance and professionalism. Each chauffeur is trained to handle high-performance vehicles with precision, ensuring safety and comfort throughout the journey. The service is perfect for airport pickups, business events, and leisure drives, offering both style and substance."
  },
  {
    "name": "Premium Sports Taxi Bangalore",
    "description": "Premium Sports Taxi Bangalore combines luxury and speed, offering the city’s best collection of elite sports cars available for hire. Whether you need a stylish entry for an event or an extraordinary travel experience, this service provides professionally managed vehicles and world-class chauffeurs. From powerful engines to luxurious interiors, every ride is designed to impress."
  },
  {
    "name": "Luxury Sports Sedan Hire Bangalore",
    "description": "Luxury Sports Sedan Hire Bangalore caters to professionals and car lovers who seek the perfect blend of comfort, style, and performance. With models like BMW M5, Audi RS7, and Mercedes AMG, it offers exhilarating performance paired with business-class elegance. The chauffeurs are well-trained to ensure smooth, safe rides, making it a top choice for both leisure and corporate travel."
  },
  {
    "name": "Sports Car Rental Bangalore",
    "description": "Sports Car Rental Bangalore provides flexible short-term and long-term rental options for high-end sports cars. The service includes premium maintenance, reliable chauffeurs, and exclusive models for customers seeking dynamic and luxurious travel experiences. It's ideal for weddings, VIP transfers, and photo shoots where presentation and performance matter most."
  },
  {
    "name": "Sports Vehicle with Driver Bangalore",
    "description": "Sports Vehicle with Driver Bangalore offers chauffeur-driven sports cars for those who want excitement without the stress of driving. With an elite fleet of luxury vehicles and well-trained drivers, this service guarantees an exhilarating experience tailored to personal and corporate occasions. Safety, comfort, and speed come together for an unforgettable ride."
  },
  {
    "name": "Book Sports Car Bangalore",
    "description": "Book Sports Car Bangalore provides a quick and hassle-free way to reserve sports cars online. Customers can explore available models, compare prices, and confirm bookings instantly. Whether for corporate transfers, weekend getaways, or personal celebrations, the process ensures convenience, transparency, and superior service."
  },
  {
    "name": "Executive Sports Cab Bangalore",
    "description": "Executive Sports Cab Bangalore delivers high-performance vehicles designed for executives and professionals who value both comfort and speed. The fleet includes sports sedans and coupes driven by skilled chauffeurs who ensure a smooth, punctual, and secure journey. Perfect for airport transfers, events, and VIP movements, this service symbolizes style and status."
  },
  {
    "name": "Affordable Sports Car Bangalore",
    "description": "Affordable Sports Car Bangalore makes luxury accessible with competitively priced rentals of top sports cars. The service caters to customers seeking a thrilling ride without compromising on quality or comfort. Each vehicle is maintained to high standards, and the service offers hourly and daily packages for added flexibility."
  },
  {
    "name": "Best Sports Cab Service Bangalore",
    "description": "Best Sports Cab Service Bangalore stands out for its premium quality, reliability, and attention to detail. Offering world-class sports cars driven by trained professionals, the service ensures that every journey delivers excitement, prestige, and absolute comfort. It’s the top choice for corporate events, weddings, and high-profile celebrations."
  },
  {
    "name": "Online Sports Taxi Booking Bangalore",
    "description": "Online Sports Taxi Booking Bangalore allows users to book their favorite sports cars in minutes using a user-friendly online interface. Customers can choose their preferred vehicle, schedule rides, and make secure payments instantly. This modern booking system guarantees convenience, efficiency, and premium service from start to finish."
  },
  {
    "name": "Exotic Car Rental Bangalore",
    "description": "Exotic Car Rental Bangalore features some of the world’s most luxurious and powerful vehicles for rent, including Lamborghini, Ferrari, and McLaren. Ideal for VIP clients, weddings, or photo shoots, the service offers flexible rental plans, professional drivers, and round-the-clock support. It’s designed for those who desire exclusivity and prestige in their travel."
  },
  {
    "name": "Sports Cab for Events Bangalore",
    "description": "Sports Cab for Events Bangalore specializes in providing stunning sports cars for corporate events, weddings, and special occasions. Each vehicle is available with or without a chauffeur, ensuring complete customization based on event requirements. The service ensures grand entries, photo-worthy moments, and unforgettable travel experiences."
  }
],
"tableData": [
  ["Sports Cab Bookings in Bangalore", "Sports Car Hire Bangalore"],
  ["Rent Sports Cab Bangalore", "Chauffeur Sports Car Bangalore"],
  ["Premium Sports Taxi Bangalore", "Luxury Sports Sedan Hire Bangalore"],
  ["Sports Car Rental Bangalore", "Sports Vehicle with Driver Bangalore"],
  ["Book Sports Car Bangalore", "Executive Sports Cab Bangalore"],
  ["Affordable Sports Car Bangalore", "Best Sports Cab Service Bangalore"],
  ["Online Sports Taxi Booking Bangalore", "Exotic Car Rental Bangalore"],
  ["Sports Cab for Events Bangalore", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Sports Cab Bookings in Bangalore",
    "WhyChoosedescription": "Aaryan Travels offers specialized sports cab bookings in Bangalore, perfect for fans and attendees of local sports events."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Travel in roomy and well-maintained cabs that accommodate sports gear and groups comfortably."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Event Venues",
    "WhyChoosedescription": "Our drivers know Bangalore’s sports venues and routes well, ensuring timely arrivals and departures."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Cabs",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe travel environment."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Enjoy clear pricing with no hidden fees, inclusive of fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from hourly, daily, or event-specific cab booking plans tailored to your needs."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs so you never miss a moment of the action."
  }
]


























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer sports cab bookings in Bangalore?',
    answer: 'Yes, Aaryan Travels provides specialized sports cab bookings in Bangalore featuring high-performance and sporty vehicles.',
  },
  {
    question: 'How can I book sports cab services in Bangalore with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Bangalore.',
  },
  {
    question: 'What types of sports vehicles are available for booking in Bangalore?',
    answer: 'Aaryan Travels offers a variety of sporty and performance cars, including models from BMW, Audi, and Mercedes for sports cab bookings.',
  },
  {
    question: 'Are drivers trained to handle sports cabs in Bangalore?',
    answer: 'Absolutely. Our drivers are experienced and trained to provide a safe, smooth, and thrilling ride in sports cabs.',
  },
  {
    question: 'Can sports cab bookings be customized for events or personal use in Bangalore?',
    answer: 'Yes, you can book sports cabs for special events, corporate functions, or personal outings anywhere in Bangalore.',
  },
  {
    question: 'Is the sports cab booking service available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels offers round-the-clock sports cab booking services to meet your schedule in Bangalore.',
  },
  {
    question: 'Are safety and hygiene protocols followed for sports cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers maintain strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are accepted for sports cab bookings in Bangalore?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the sports cab booking period in Bangalore?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your sports cab booking.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Siddharth Rao',
    feedback: 'Aaryan Travels made booking a sports cab in Bangalore exciting and hassle-free. Excellent cars and drivers!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nisha Gupta',
    feedback: 'Highly recommend Aaryan Travels for sports cab bookings in Bangalore. The cars were thrilling and the service was top-notch.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const sportsCabBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Sports Cab Bookings in Bangalore",
  "description": "Aaryan Travels provides premium sports cab bookings in Bangalore. Rent exotic and luxury sports cars with professional chauffeurs for events, business, and personal travel at affordable rates.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Sports Car Rental",
  "keywords": "Sports Cab Bookings in Bangalore, Sports Car Hire Bangalore, Rent Sports Cab Bangalore, Chauffeur Sports Car Bangalore, Premium Sports Taxi Bangalore, Luxury Sports Sedan Hire Bangalore, Sports Car Rental Bangalore, Sports Vehicle with Driver Bangalore, Book Sports Car Bangalore, Executive Sports Cab Bangalore, Affordable Sports Car Bangalore, Best Sports Cab Service Bangalore, Online Sports Taxi Booking Bangalore, Exotic Car Rental Bangalore, Sports Cab for Events Bangalore"
};









  return (
    <div>

<Helmet>
  <title>Sports Cab Bookings in Bangalore | Exotic & Luxury Sports Car Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book sports cab rentals in Bangalore with Aaryan Travels. Rent exotic and luxury sports cars with chauffeurs for events, business trips, and personal rides at competitive prices."
  />
  <meta
    name="keywords"
    content="Sports Cab Bookings in Bangalore, Sports Car Hire Bangalore, Rent Sports Cab Bangalore, Chauffeur Sports Car Bangalore, Premium Sports Taxi Bangalore, Luxury Sports Sedan Hire Bangalore, Sports Car Rental Bangalore, Sports Vehicle with Driver Bangalore, Book Sports Car Bangalore, Executive Sports Cab Bangalore, Affordable Sports Car Bangalore, Best Sports Cab Service Bangalore, Online Sports Taxi Booking Bangalore, Exotic Car Rental Bangalore, Sports Cab for Events Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(sportsCabBangaloreSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sportscabbookinginbanglore;